import useAuth from "../../../lib/hooks/useAuth";
import { getProfile } from "../../../services/profileService";
import { USER_DATA } from "../../../lib/const";
import NewQuestionItem, { isNonKpi } from "./NewQuestionItem";
import { buildExtendedAnswers } from "./buildExtendedAnswers";
import {
  ArrowLeftOutlined,
  ArrowUpOutlined,
  CaretDownFilled,
  CaretUpFilled,
  DeleteFilled,
  MailOutlined,
  PhoneFilled,
  PlusOutlined,
  UploadOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  FloatButton,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Upload,
  message,
  theme,
  Flex,
  Radio,
  Checkbox,
  AutoComplete,
  
} from "antd";

import axios from "axios";
import moment from "moment";
import React, { useCallback, useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APPCONFIG } from "../../../Config";
import NotFoundIcon from "../../../assets/images/icon/notFoundIcon.svg";
import Heading from "../../../components/common/heading";
import ConfirmModal from "../../../components/modal/confirmModal";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import {
  ACCESS_TOKEN,
  BUSINESS_REQUIRE,
  COMPANY_TYPE,
  CUSTOMER_EXPECT,
  CUSTOMER_SUPPORT,
  DATA_MASTER_DATA_TYPE,
  ERR_0022,
  ESTATE_TYPE,
  EXPECTED,
  INDUSTRY,
  CURRENT_CUSTOMER_INDUSTRY_TYPE,
  OTHER_BUSINESS_EXPECT,
  OTHER_PRODUCT_EXPECT,
  OTHER_SUPPORT_EXPECT,
  PRODUCT_REQUIREMENT,
  PROVICE,
  REGION_GROUP,
  SUCCESS_CODE,
  TOUCH_POINT_CHANNEL_DIGITAL,
  TOUCH_POINT_CHANNEL_PHYSICAL,
  VOC_MASTER_DATA_TYPE,
  WORK_PERIOD,
} from "../../../lib/const";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import useCountry from "../../../lib/hooks/useCountry";
import useCustomerTabs from "../../../lib/hooks/useCustomerTabs";
import useEState from "../../../lib/hooks/useEState";
import useLineOfWork from "../../../lib/hooks/useLineOfWork";
import useMasterData from "../../../lib/hooks/useMasterData";
import usePosition from "../../../lib/hooks/usePosition";
import useStaffName from "../../../lib/hooks/useStaffName";
import { routes } from "../../../routes";
import { createCurrentCustomer,searchProductAutoComplete  } from "../../../services/customerCurrent";
import APIEndpoint from "../../../services/endpoint";
import WithSidebar from "../../../templates/withSidebar";
import "./style.css";
import {MultipleAutoComplete,Autocomplete} from "../../../components/common/autoCompleteV2";

const { useToken } = theme;
const { Option } = Select;

const months = [
  {
    value: 1,
    name: "ตุลาคม",
  },
  {
    value: 2,
    name: "พฤศจิกายน",
  },
  {
    value: 3,
    name: "ธันวาคม",
  },
  {
    value: 4,
    name: "มกราคม",
  },
  {
    value: 5,
    name: "กุมภาพันธ์",
  },
  {
    value: 6,
    name: "มีนาคม",
  },
  {
    value: 7,
    name: "เมษายน",
  },
  {
    value: 8,
    name: "พฤษภาคม",
  },
  {
    value: 9,
    name: "มิถุนายน",
  },
  {
    value: 10,
    name: "กรกฎาคม",
  },
  {
    value: 11,
    name: "สิงหาคม",
  },
  {
    value: 12,
    name: "กันยายน",
  },
];
const years = moment().add(1, "years").format("YYYY");

export const AddCurrentCustomer = () => {
  const { auth, setAuth } = useAuth();
  const isNonKpiUser = isNonKpi(auth?.user?.nonKpiUser);
  useEffect(() => {
    let active = true;
    getProfile().then(({ data }) => {
      if (active && data.code === "0000") {
        setAuth({ user: data.objectValue, isLogin: true });
        localStorage.setItem(USER_DATA, JSON.stringify(data.objectValue));
      }
    }).catch(() => message.error("ไม่สามารถโหลดข้อมูลผู้ใช้ได้ กรุณาลองใหม่"));
    return () => { active = false; };
  }, [setAuth]);
  //test
  const [checkedValues1, setCheckedValues1] = useState({});
  const [checkedValues2, setCheckedValues2] = useState({});
  const options = [
    { label: 'เพิ่ม', value: '1' },
    { label: 'ลด', value: '-1' },
    { label: 'เท่าเดิม', value: '0' },

  ];
  const options11 = [
    { label: 'เป็นไปตามแผน', value: '1' },
    { label: 'ไม่เป็นไปตามแผน', value: '0' },
  ];
  const options6 = [
    { label: 'มี', value: '1' },
    { label: 'ไม่มี', value: '0' },
  ];
  const options12 = [
    { label: 'ใช่', value: 'true' },
    { label: 'ไม่ใช่', value: 'false' },
  ];
  const planOptions = ['Solar Cell', 'น้ำ Recycle RO', 'พลังงานลม','พลังงานไฮโดรเจน','อื่นๆ'];

  const [modes, setModes] = useState({
    capacity: {},
    electricity: {},
    water: {},
    ro: {},
    CapacityPlan:{
      k:{
        choicesReducePlan: {},     
        choicesFuturePlan: {},
        isSelectReduce: null,     
        isSelectFuture: null,    
        
      }
    },
  });
  const [autoProd, setAutoProd] = useState("");
  const [optionsProd, setOptionsProd] = useState([]);
  
  useEffect(() => {
    const fetchAllProducts = async () => {
        const res = await searchProductAutoComplete("");
        const list = res?.data?.objectValue || [];
        setOptionsProd(list);
      
    };

    fetchAllProducts();
  }, []);

  const handleSelect = (selectedValue) => {
    setAutoProd(selectedValue);
  };
  const handleRadioLevelChange = (type, key, level) => (e) => {
    const value = e.target.value;
  
    setModes((prev) => {
      const prevData = prev[type]?.[key] || {};
  
      const newData = {
        ...prevData,
        [level]: value,
      }; 
      if (level === "choicesReducePlan") {
        if (value === "1") {
          newData.choicesFuturePlan = null;
          setCheckedValues2((prev) => ({ ...prev, [key]: [] }));
          form.setFieldsValue({
            isSelectFuture: {
              ...form.getFieldValue("isSelectFuture"),
              [key]: [],
            },
          });
        } else {
          form.setFieldsValue({
            isSelectReduce: {
              ...form.getFieldValue("isSelectReduce"),
              [key]: [],
            },
          });
          setCheckedValues1((prev) => ({ ...prev, [key]: [] }));
        }
      }
      
      if (level === "choicesFuturePlan" && value === "0") {
        form.setFieldsValue({
          isSelectFuture: {
            ...form.getFieldValue("isSelectFuture"),
            [key]: [],
          },
        });
        setCheckedValues2((prev) => ({ ...prev, [key]: [] }));
      }
      
  
      return {
        ...prev,
        [type]: {
          ...prev[type],
          [key]: newData,
        },
      };
    });
  };

  const handleCheckedChange2 = (key) => (checkedValues) => {
    setCheckedValues2((prev) => ({
      ...prev,
      [key]: Array.isArray(checkedValues) ? checkedValues : [checkedValues],
    }));
  
    const updatedisSelectFuture = form.getFieldValue('isSelectFuture') || {};
    form.setFieldsValue({
      isSelectFuture: {
        ...updatedisSelectFuture,
        [key]: Array.isArray(checkedValues) ? checkedValues : [checkedValues], 
      },
    });

    // form.setFieldsValue({
    //   isSelectFuture: {
    //     ...form.getFieldValue('isSelectFuture'),
    //     [key]: checkedValues
    //   },
    // });
  
    if (!checkedValues.includes("อื่นๆ")) {
      form.setFieldsValue({
        otherFuture: {
          [key]: undefined,
        },
      });
    }

  };
  
  const [disabled, setDisabled] = useState(true);
  const handleRadioChange = (type, key) => (e) => {
    const value = e.target.value;
    setModes((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  
    // if (type === "capacity") {
    //   setDisabled(value === "0");
  
    //   if (value === "0") {
    //     form.setFieldsValue({
    //       capacity_add: 0,
    //       capacity_sub: 0,
    //     });
    //   }
    //   if (value === "1") {
    //     form.setFieldsValue({
    //       capacity_sub: 0,
    //     });
    //   }
    //   if (value === "-1") {
    //     form.setFieldsValue({
    //       capacity_add: 0,
    //     });
    //   }
    // }
  
    // if (type === "electricity") {
    //   if (value === "0") {
    //     form.setFieldsValue({
    //       electricity_add: 0,
    //       electricity_sub: 0,
    //     });
    //   }
    //   if (value === "1") {
    //     form.setFieldsValue({
    //       electricity_sub: 0,
    //     });
    //   }
    //   if (value === "-1") {
    //     form.setFieldsValue({
    //       electricity_add: 0,
    //     });
    //   }
    // }
    // if (type === "water") {
    //   if (value === "0") {
    //     form.setFieldsValue({
    //       water_add: 0,
    //       water_sub: 0,
    //     });
    //   }
    //   if (value === "1") {
    //     form.setFieldsValue({
    //       water_sub: 0,
    //     });
    //   }
    //   if (value === "-1") {
    //     form.setFieldsValue({
    //       water_add: 0,
    //     });
    //   }
    // }
    // if (type === "ro") {
    //   if (value === "0") {
    //     form.setFieldsValue({
    //       ro_add: 0,
    //       ro_sub: 0,
    //     });
    //   }
    //   if (value === "1") {
    //     form.setFieldsValue({
    //       ro_sub: 0,
    //     });
    //   }
    //   if (value === "-1") {
    //     form.setFieldsValue({
    //       ro_add: 0,
    //     });
    //   }
    // }
  };
  




  //
  const { token } = useToken();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [lineOfWork] = useLineOfWork();
  const [estate] = useEState();
  const [position] = usePosition();
  const [countries] = useCountry();
  const { setTabs } = useCustomerTabs();
  const [companyType] = useMasterData(DATA_MASTER_DATA_TYPE, COMPANY_TYPE);
  const [regionGroup] = useMasterData(DATA_MASTER_DATA_TYPE, REGION_GROUP);
  const [industryType] = useMasterData(DATA_MASTER_DATA_TYPE, CURRENT_CUSTOMER_INDUSTRY_TYPE);
  // const [industry] = useMasterData(DATA_MASTER_DATA_TYPE, INDUSTRY);
  const [estateType] = useMasterData(DATA_MASTER_DATA_TYPE, ESTATE_TYPE);
  const [provinces] = useMasterData("", PROVICE);
  const [workPeriod] = useMasterData(DATA_MASTER_DATA_TYPE, WORK_PERIOD);
  const [expected] = useMasterData(DATA_MASTER_DATA_TYPE, EXPECTED);
  const [touchPointChannel] = useMasterData(
    DATA_MASTER_DATA_TYPE,
    TOUCH_POINT_CHANNEL_DIGITAL
  );
  const [touchPointChannelPhysical] = useMasterData(
    DATA_MASTER_DATA_TYPE,
    TOUCH_POINT_CHANNEL_PHYSICAL
  );
  const [businessRequire] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    BUSINESS_REQUIRE
  );
  const [customerExpect] = useMasterData(VOC_MASTER_DATA_TYPE, CUSTOMER_EXPECT);
  const [customerSupport] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    CUSTOMER_SUPPORT
  );
  const [productRequirement] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    PRODUCT_REQUIREMENT
  );
  const [otherBusinessExpect] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_BUSINESS_EXPECT
  );
  const [otherProductExpect] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_PRODUCT_EXPECT
  );
  const [otherSupportExpect] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_SUPPORT_EXPECT
  );
  let [industries] = useMasterData("", INDUSTRY);
  let [filteredIndustries, setFilteredIndustries] = useState([]);

  const [staffName] = useStaffName();
  const values = Form.useWatch([], form);
  const [elems, setElems] = useState([]);
  const [visitors, setVisitors] = useState([]);
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [fileList, setFileList] = useState([]);

  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    id: 0,
  });

  const closeConfirmModal = useCallback(() => {
    setConfirmModal({
      id: 0,
      type: "",
      show: false,
    });
  }, []);

  const onFinish = async (values) => {
    const unique = visitors.filter(
      (obj, index) => visitors.findIndex((item) => item.id === obj.id) === index
    );
    // const allProducts = Object.values(values?.item).flatMap(group =>
    //   group.map(item => item.productBuy)
    // );
    // const groupZero = values?.item[0];
    // const productFromGroupZero = groupZero?.map(item => item.productBuy);
    // console.log(productFromGroupZero);
    // console.log(allProducts);
    let arrObj = [];
    let i = 1;
    for (let j = 0; j < elems.length; j++) {
        
        const otherReduceText = values?.otherReduce?.[j];
        const selectReduce = Array.isArray(values?.isSelectReduce?.[j])
        ? values.isSelectReduce[j]
        :  [];
        const finalSelectReduce = selectReduce.map(item =>
          item === "อื่นๆ"
            ? (otherReduceText ? `อื่นๆ: ${otherReduceText}` : "อื่นๆ")
            : item
        );
        const otherFutureText = values?.otherFuture?.[j];
        const SelectFuture = Array.isArray(values?.isSelectFuture?.[j])
        ? values.isSelectFuture[j]
        : [];
        const finalSelectFuture = SelectFuture.map(item =>
          item === "อื่นๆ"
            ? (otherFutureText ? `อื่นๆ: ${otherFutureText}` : "อื่นๆ")
            : item
        );
      arrObj[j] = {
        summaryEstateId: [values?.summaryEstateId[j]],
        yearOfBudget: values?.yearOfBudget[j],
        monthOfBudget: values?.monthOfBudget[j],
        staffName: values?.staffName[j],
        reporterName: values?.reporterName[j],
        reporterPosition: values?.reporterPosition[j],
        reporterPhoneNumber: values?.reporterPhoneNumber[j],
        reporterEmail: values?.reporterEmail[j],
        areaSizeByRai: values?.areaSizeByRai[j],
        areaSizeByNgan: values?.areaSizeByNgan[j],
        areaSizeByWa: values?.areaSizeByWa[j],
        areaSizeByMeters: values?.areaSizeByMeters[j],
        waterConsumption: values?.waterConsumption[j],
        numberOfWorker: values?.numberOfWorker[j],
        ceoNameOfFactory: values?.ceoNameOfFactory[j],
        ceoPositionOfFactory: values?.ceoPositionOfFactory[j],
        coordinatorName: values?.coordinatorName[j],
        coordinatorPhoneNumber: values?.coordinatorPhoneNumber[j] || "",
        coordinatorEmail: values?.coordinatorEmail[j] || "",
        filePath: values?.filePath[j] || "",
        productAndServiceWant: values?.productAndServiceWant[j] || [],
        productAndServiceWantSpecify: values?.productAndServiceWantSpecify
          ? values?.productAndServiceWantSpecify[j]
          : "",
        productAndServiceExpected: values?.productAndServiceExpected[j] || [],
        productAndServiceExpectedSpecify:
          values?.productAndServiceExpectedSpecify
            ? values?.productAndServiceExpectedSpecify[j]
            : "",
        supportWant: values?.supportWant[j] || [],
        supportWantSpecify: values?.supportWantSpecify
          ? values?.supportWantSpecify[j]
          : "",
        supportExpected: values?.supportExpected[j] || [],
        supportExpectedSpecify: values?.supportExpectedSpecify
          ? values?.supportExpectedSpecify[j]
          : "",
        transactionWant: values?.transactionWant[j] || [],
        transactionWantSpecify: values?.transactionWantSpecify
          ? values?.transactionWantSpecify[j]
          : "",
        transactionExpected: values?.transactionExpected[j] || [],
        transactionExpectedSpecify: values?.transactionExpectedSpecify
          ? values?.transactionExpectedSpecify[j]
          : "",
        crmExpected: values?.crmExpected[j] || "",
        crmExpectedSpecify: values?.crmExpectedSpecify
          ? values?.crmExpectedSpecify[j]
          : "",
        productAndServiceSuggestion:
          values?.productAndServiceSuggestion[j] || "",
        supportSuggestion: values?.supportSuggestion[j] || "",
        transactionSuggestion: values?.transactionSuggestion[j] || "",
        crmSuggestion: values?.crmSuggestion[j] || "",
        notSatisfied: values?.notSatisfied[j] || "",
        buyOrRentLand: values?.buyOrRentLand[j],
        buyOrRentLandProvince: values?.buyOrRentLandProvince
          ? values?.buyOrRentLandProvince[j]
          : "",
        buyOrRentLandEstate: values?.buyOrRentLandEstate
          ? values?.buyOrRentLandEstate[j]
          : "",
        buyOrRentLandYear: values?.buyOrRentLandYear
          ? values?.buyOrRentLandYear[j]
          : "",
        buyOrRentLandRai: values?.buyOrRentLandRai
          ? values?.buyOrRentLandRai[j]
          : "",
        digitalContact: values?.digitalContact[j],
        digitalContactSpecify: values?.digitalContactSpecify
          ? values?.digitalContactSpecify[j]
          : "",
        physicalContact: values?.physicalContact[j],
        contactSuggestion: values?.contactSuggestion[j],

        

        summaryVisitorExtended: buildExtendedAnswers(values, j, finalSelectReduce, finalSelectFuture, "add", isNonKpiUser),
      };

        
      i++;
    }
    

    const request = {
      dbdRegisterNumber: values?.dbdRegisterNumber,
      factoryNameEn: values?.factoryNameEn,
      factoryNameTh: values?.factoryNameTh,
      lineOfWorkId: values?.lineOfWorkId,
      estateId: values?.estateId,
      estateNameEn: values?.estateNameEn,
      customerGroupByAge: values?.customerGroupByAge,
      customerGroupByRegion: values?.customerGroupByRegion,
      customerRegion: [values?.customerRegion],
      typeOfBusiness: values?.typeOfBusiness,
      typeOfEstate: values?.typeOfEstate,
      customerGroupByEstateType: values?.customerGroupByEstateType,
      summaryVisitor: arrObj,
    };
    const res = await createCurrentCustomer(request);
    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setTimeout(() => {
        navigate(routes.customer + `?menu=customer&tab=current`);
        setSuccessModal(false);
      }, 2000);
    } else {
      if (res.data.code === ERR_0022) {
        form.setFields([
          {
            name: "dbdRegisterNumber",
            errors: [
              "เลขทะเบียนพาณิชย์ DBD Register number นี้มีอยู่ในระบบแล้วกรุณาตรวจสอบข้อมูล",
            ],
          },
        ]);
      } else {
        setFailModal(true);
      }
      setFailModal(true);
      setTimeout(() => {
        setFailModal(false);
      }, 2000);
    }
  };

    const onFinishFailed = (errorInfo) => {
    // Get the name of the first field with an error
    const firstErrorField = errorInfo.errorFields[0].name;

    let fieldId = Array.isArray(firstErrorField) ? firstErrorField.join('_') : firstErrorField;
    fieldId = fieldId + "_help";

    // Get a reference to the DOM element of that field
    const errorFieldElement = document.getElementById(fieldId);

    if (errorFieldElement) {
      // Scroll to the element
      errorFieldElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center', // Scrolls the element to the center of the view
      });
    }
  };

  const columns = [
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "ตำแหน่ง",
      dataIndex: "position",
      key: "position",
      render: (_, record) => <>{record.position || "-"}</>,
    },
    {
      width: 100,
      align: "center",
      title: "คำสั่ง",
      dataIndex: "",
      key: "",
      render: (_, record) => (
        <Button
          shape="circle"
          size="small"
          style={{ background: "#FDE7E5", border: "1px solid#FDE7E5" }}
          onClick={() => {
            const selected = form.getFieldValue(["staffName", record.index]);

            let newArr = [];
            for (let i = 0; i < selected?.length; i++) {
              if (selected[i] !== record.id) {
                newArr.push(selected[i]);
              }
            }
            form.setFields([
              {
                name: ["staffName", record.index],
                value: newArr.length > 0 ? newArr : undefined,
              },
            ]);
            let newArrVisitors = [];
            for (let i = 0; i < visitors?.length; i++) {
              if (record.index === visitors[i].index) {
                if (record.id !== visitors[i].id) {
                  newArrVisitors.push(visitors[i]);
                }
              }
            }

            for (let i = 0; i < visitors?.length; i++) {
              if (record.index !== visitors[i].index) {
                newArrVisitors.push(visitors[i]);
              }
            }

            setVisitors(newArrVisitors);
          }}
        >
          <DeleteFilled style={{ color: "#F04438" }} />
        </Button>
      ),
    },
  ];

  const addElems = () => {
    const newObj = {
      collapse: true,
      index: elems?.length,
    };
    setElems((prev) => [...prev, newObj]);

    setTimeout(() => {
      form.setFieldsValue({
        sellProductTo: {
          [newObj.index]: [{}],
        },
        buyProductFrom : {
          [newObj.index]:[{}],
        },
        bigImportTo : {
          [newObj.index]:[{}],
        },
        TaxEffect : {
          [newObj.index]:[{}],
        },
      });
    }, 0);
  };

  const removeElems = () => {
    setElems((current) => current.filter((e) => e.index !== confirmModal.id));

    closeConfirmModal();
  };

  const collapseElems = (el) => {
    setElems(
      elems.map((item) =>
        item.index === el.index
          ? {
              ...item,
              collapse: !el?.collapse,
            }
          : {
              ...item,
              collapse: false,
            }
      )
    );
  };

  const addVisitor = (visitor, index) => {
    const staffs = form.getFieldValue(["staffName", index]);

    for (let i = 0; i < staffs?.length; i++) {
      for (let j = 0; j < staffName?.length; j++) {
        if (staffs[i] === staffName[j].id) {
          setVisitors((prev) => [
            ...prev,
            {
              index: index,
              id: staffName[j].id,
              memberName: staffName[j].staffName,
              memberLastname: staffName[j].staffLastname,
              position: staffName[j].position,
            },
          ]);
        }
      }
    }
  };

  const props = {
    beforeUpload: (file) => {
      const allowType =
        file.type === "image/jpeg" || file.type === "application/pdf";
      if (!allowType) {
        message.error(`${file.name} is not a  JPG, PDF file`);
      }
      return allowType || Upload.LIST_IGNORE;
    },
    onChange: (info) => {},
  };

  const onRemoveFile = (info, index) => {
    form.setFields([
      {
        name: ["filePath", index],
        value: "",
        errors: [],
      },
    ]);
    let newData = fileList.filter((item) => item.index !== index);
    setFileList(newData);
  };

  const onUploadFile = async (info, index) => {
    const newObj = {
      index: index,
      file: info.file.name,
      name: info.file.name,
      status: "uploading",
      uid: info.file.uid,
      url: "",
    };

    let formData = new FormData();
    formData.append("file", info.file);

    const api = APIEndpoint.UPLOAD_FILE_API;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        "content-type": "multipart/form-data",
      },
    };
    const res = await axios.post(
      APPCONFIG.GATEWAY_ENDPOINT + api,
      formData,
      config
    );
    if (res?.data?.code === SUCCESS_CODE) {
      message.success(`${res.data.message}`);
      const { objectValue } = res.data;
      newObj.status = "done";
      newObj.file = objectValue.fileName;
      newObj.name = objectValue.fileName;

      if (fileList.length === 0) {
        setFileList([newObj]);
      } else {
        let newData = fileList.filter((item) => item.index !== index);
        newData.push(newObj);
        setFileList(newData);
      }
      form.setFields([
        {
          name: ["filePath", index],
          value: objectValue.filePath,
          errors: [],
        },
      ]);
    } else {
      newObj.status = "error";
      message.error(`${res.data.message}`);
    }
  };

  const onCustomerGroupByEstateType = () => {
    let arr = form.getFieldValue().customerGroupByEstateType;

    // all, ไม่สามารถระบุได้
    if (
      !arr.includes("all") &&
      !arr.includes("84fc6124-d73b-11ef-8f16-005056014b8c")
    ) {
      if (
        // basic : ทั่วไป
        arr.includes("8a739cff-d73b-11ef-8f16-005056014b8c") &&
        !arr.includes("7e32ffb0-d73b-11ef-8f16-005056014b8c")
      ) {
        let newObj = industries.filter((item) => item.isBasicIndustry);
        setFilteredIndustries(newObj);
      } else {
        // s-curve
        let newObj = industries.filter((item) => item.isSCurve);
        setFilteredIndustries(newObj);
      }
    } else {
      setFilteredIndustries([]);
    }
  };

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.customer_tab_current);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"เพิ่มข้อมูล"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูลลูกค้าปัจจุบัน",
                },
                {
                  title: <span className="pr_green">เพิ่มข้อมูล</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError={{ behavior: 'smooth' }}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.customer_tab_current);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Heading
                    text={"ข้อมูลลูกค้าปัจจุบัน"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="เลขทะเบียนพาณิชย์ DBD Register number (กรอกเป็นตัวเลข 13 หลัก)"
                    name={"dbdRegisterNumber"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                        pattern: new RegExp(/([0-9])/g),
                      },
                    ]}
                  >
                    <Input
                      maxLength={13}
                      placeholder="เลขทะเบียนพาณิชย์ DBD Register number"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="ชื่อสถานประกอบการ/ชื่อโรงงาน (TH)"
                    name={"factoryNameTh"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="ชื่อสถานประกอบการ/ชื่อโรงงาน (TH)" />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ชื่อสถานประกอบการ/ชื่อโรงงาน (EN)"
                    name={"factoryNameEn"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="ชื่อสถานประกอบการ/ชื่อโรงงาน (EN)" />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[8, 16]}>
                    <Col span={24}>
                      <Form.Item
                        label="สายงาน"
                        name={"lineOfWorkId"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                        >
                          {lineOfWork.map((item) => (
                            <Option value={item.lineOfWork}>
                              {item.nameTh}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="ระบุชื่อนิคมอุตสาหกรรม/ท่าเรืออุตสาหกรรม (ตอบได้มากกว่า 1 ข้อ)"
                        name={"estateNameEn"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <MultipleAutoComplete
                            subject="estateName"
                              valueField="estateId"
                              labelField="estateNameTh"
                              placeholder="กรุณาเลือก"
                          />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="นิคมอุตสาหกรรม (ตอบได้มากกว่า 1 ข้อ)"
                        name={"estateId"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          mode="multiple"
                          maxTagCount={"responsive"}
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                        >
                          {estateType.map((item) => (
                            <Option value={item.dataId}>
                              {item.dataDetailTh}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="กลุ่มลูกค้าตามอายุ"
                    name={"customerGroupByAge"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {workPeriod.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="กลุ่มลูกค้าตามสัญชาติ (ตอบได้มากกว่า 1 ข้อ)"
                    name={"customerGroupByRegion"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      mode="multiple"
                      maxTagCount={"responsive"}
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {regionGroup.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="สัญชาติลูกค้า (ประเทศ)"
                    name={"customerRegion"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    {/* <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {countries.map((item) => (
                        <Option key={item.countryId} value={item.countryId}>
                          {item.countryNameTh}
                        </Option>
                      ))}
                    </Select> */}
                    <MultipleAutoComplete
                      multiple={false}
                      subject="countryOrderNameTh"
                      valueField="countryId"
                      labelField="countryNameTh"
                      placeholder="กรุณาเลือก"
                    />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[8, 16]}>
                    <Col span={12}>
                      <Form.Item
                        label="ลูกค้าตามกลุ่มอุตสาหกรรม"
                        name={"customerGroupByEstateType"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                          onChange={onCustomerGroupByEstateType}
                        >
                          {industryType.map((item) => (
                            <Option key={item.dataId} value={item.dataId}>
                              {item.dataDetailTh}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="ประเภทอุตสาหกรรม"
                        name={"typeOfEstate"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                        >
                          {filteredIndustries?.length > 0
                            ? filteredIndustries.map((item) => (
                                <Option
                                  key={item.industryId}
                                  value={item.industryId}
                                >
                                  {item.industryNameTh}
                                </Option>
                              ))
                            : industries.map((item) => (
                                <Option
                                  key={item.industryId}
                                  value={item.industryId}
                                >
                                  {item.industryNameTh}
                                </Option>
                              ))}
                          <Option value={-99}>อื่นๆ</Option>
                        </Select>
                      </Form.Item>
                      {values?.typeOfEstate === -99 && (
                        <Form.Item
                          label=""
                          name={"typeOfEstateSpecify"}
                          style={{ marginTop: 8 }}
                        >
                          <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                      )}
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="ประเภทกิจการ"
                        name={"typeOfBusiness"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                        >
                          {companyType.map((item) => (
                            <Option value={item.dataId}>
                              {item.dataDetailTh}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row
                gutter={[16, 8]}
                className="card addElement"
                style={{ marginTop: 30, marginBottom: 50 }}
              >
                <Col span={24}>
                  <Heading
                    text={"Summary สรุปการเยี่ยมชม"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                {elems &&
                  elems.map((el, k) => (
                    <Col key={k} span={24}>
                      <div
                        className={`relative`}
                        style={{
                          padding: 15,
                          marginBottom: 20,
                          width: "80%",
                          border: "1px solid #E5EAEE",
                          borderRadius: 10,
                        }}
                      >
                        <Row
                          gutter={[16, 8]}
                          className={`${
                            el.collapse ? "" : "add-current-custom-collapse"
                          }`}
                        >
                          <div className="add-current-custom-collapse-btn">
                            <Button
                              shape="circle"
                              size="small"
                              style={{
                                backgroundColor: "#FDE7E5",
                                border: 0,
                              }}
                              onClick={() => {
                                setConfirmModal({
                                  id: el?.index,
                                  show: true,
                                  type: "delete",
                                });
                              }}
                            >
                              <DeleteFilled style={{ color: "#F04438" }} />
                            </Button>
                            <Button
                              shape="circle"
                              size="small"
                              style={{
                                backgroundColor: "#F4F6FC",
                                border: 0,
                                marginLeft: 5,
                              }}
                              onClick={() => collapseElems(el)}
                            >
                              {el.collapse ? (
                                <CaretUpFilled
                                  style={{
                                    color: "#2E90FA",
                                    fontSize: 16,
                                  }}
                                />
                              ) : (
                                <CaretDownFilled
                                  style={{
                                    color: "#2E90FA",
                                    fontSize: 16,
                                  }}
                                />
                              )}
                            </Button>
                          </div>

                          <Col span={24}>
                            <div style={{ fontWeight: 600, fontSize: 16 }}>
                              ข้อมูลการเข้าเยี่ยมชมลูกค้า{" "}
                            </div>
                          </Col>

                          <Col span={24}>
                            <Form.Item
                              label="ระบุชื่อนิคมอุตสาหกรรม/ท่าเรืออุตสาหกรรม"
                              name={["summaryEstateId", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <MultipleAutoComplete
                                multiple={false}
                                subject="estateName"
                                  valueField="estateId"
                                  labelField="estateNameTh"
                                  placeholder="กรุณาเลือก"
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              label="ปีงบประมาณ"
                              name={["yearOfBudget", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {(() => {
                                  let arr = [];
                                  for (let i = 0; i < 5; i++) {
                                    arr.push(
                                      <Option
                                        key={parseInt(years - i)}
                                        value={parseInt(years - i)}
                                      >
                                        {parseInt(years) + 543 - i}
                                      </Option>
                                    );
                                  }
                                  return arr;
                                })()}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              label="เดือน"
                              name={["monthOfBudget", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {months.map((m) => (
                                  <Option value={m.value}>
                                    เดือน {m.value} &nbsp;&nbsp;({m.name})
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col span={24} style={{ marginTop: 20 }}>
                            <Form.Item
                              label="ชื่อเจ้าหน้าที่เข้าเยี่ยมลูกค้า (ระบุได้มากกว่า 1 ชื่อ)"
                              name={["staffName", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <MultipleAutoComplete
                                multiple={true}
                                subject="staffName"
                                  valueField="staffUniqueId"
                                  labelField="staffFullName"
                                  placeholder="กรุณาเลือก"
                              />
                            </Form.Item>
                          </Col>

                          <Col span={24}>
                            <div style={{ marginTop: 5, marginBottom: 20 }}>
                              <span style={{ fontWeight: 500 }}>
                                จำนวนรายชื่อทั้งหมด{" "}
                                <span
                                  className="pr-purple"
                                  style={{ fontWeight: 600 }}
                                >
                                  {form.getFieldValue(["staffName", k])?.length}
                                </span>{" "}
                                คน
                              </span>
                              <table
                                style={{
                                  overflow: "hidden",
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr
                                    style={{
                                      background: "#fafafa",
                                      textAlign: "left",
                                    }}
                                  >
                                    <th style={{ padding: 8 }}>ชื่อ-นามสกุล</th>
                                    {/* <th style={{ padding: 8 }}>ตำแหน่ง</th> */}
                                    <th
                                      width={200}
                                      align="center"
                                      style={{ padding: 8 }}
                                    >
                                      คำสั่ง
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {form.getFieldValue(["staffName", k])
                                    ?.length > 0 ? (
                                    form
                                      .getFieldValue(["staffName", k])
                                      .map((item) =>
                                        staffName.map(
                                          (s) =>
                                            s.id === item && (
                                              <tr>
                                                <td style={{ padding: 8 }}>
                                                  {s.value || "-"}
                                                </td>
                                                {/* <td style={{ padding: 8 }}>
                                                  {s.position || "-"}
                                                </td> */}
                                                <td
                                                  align="center"
                                                  style={{ padding: 8 }}
                                                >
                                                  <Button
                                                    shape="circle"
                                                    size="small"
                                                    style={{
                                                      background: "#FDE7E5",
                                                      border:
                                                        "1px solid#FDE7E5",
                                                    }}
                                                    onClick={() => {
                                                      const selected =
                                                        form.getFieldValue([
                                                          "staffName",
                                                          k,
                                                        ]);

                                                      let newArr = [];
                                                      for (
                                                        let i = 0;
                                                        i < selected?.length;
                                                        i++
                                                      ) {
                                                        if (
                                                          selected[i] !== s.id
                                                        ) {
                                                          newArr.push(
                                                            selected[i]
                                                          );
                                                        }
                                                      }
                                                      form.setFields([
                                                        {
                                                          name: [
                                                            "staffName",
                                                            k,
                                                          ],
                                                          value:
                                                            newArr.length > 0
                                                              ? newArr
                                                              : undefined,
                                                        },
                                                      ]);
                                                    }}
                                                  >
                                                    <DeleteFilled
                                                      style={{
                                                        color: "#F04438",
                                                      }}
                                                    />
                                                  </Button>
                                                </td>
                                              </tr>
                                            )
                                        )
                                      )
                                  ) : (
                                    <tr style={{ width: "100%" }}>
                                      <td align="center" colspan="3">
                                        <div
                                          style={{
                                            margin: "40px 0",
                                            width: "100%",
                                          }}
                                        >
                                          <img
                                            src={NotFoundIcon}
                                            width={150}
                                            alt="Not Found Icon"
                                          />
                                          <p
                                            style={{
                                              color: "#464E5F",
                                              fontWeight: 500,
                                              fontSize: "18px",
                                            }}
                                          >
                                            {
                                              "สามารถเพิ่มรายชื่อได้ที่ช่องกรอกด้านบน “เจ้าหน้าที่เข้าเยี่ยมลูกค้า”"
                                            }
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </Col>

                          <Col span={24}>
                            <Form.Item
                              label="ชื่อ-นามสกุล ผู้จัดทำรายงาน"
                              name={["reporterName", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <MultipleAutoComplete
                                multiple={false}
                                subject="staffName"
                                  valueField="staffUniqueId"
                                  labelField="staffFullName"
                                  placeholder="กรุณาเลือก"
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              label="ตำแหน่งผู้จัดทำรายงาน"
                              name={["reporterPosition", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select placeholder="ตำแหน่งผู้จัดทำรายการ">
                                {position &&
                                  position.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                      {item.value}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              label="เบอร์โทรผู้จัดทำรายงาน"
                              name={["reporterPhoneNumber", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Input
                                prefix={<PhoneFilled />}
                                placeholder="Ex.080-000-0000"
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              label="E-mail ผู้จัดทำรายงาน"
                              name={["reporterEmail", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                  type: "email",
                                },
                              ]}
                            >
                              <Input
                                prefix={<MailOutlined />}
                                placeholder="Ex.abc@gmail.com,hotmail.com..."
                              />
                            </Form.Item>
                          </Col>

                          <Col span={24}>
                            <Divider dashed />
                          </Col>

                          <Col span={24}>
                            <div style={{ fontWeight: 600, fontSize: 16 }}>
                              ข้อมูลลูกค้า
                            </div>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="ขนาดพื้นที่ (ไร่)"
                              name={["areaSizeByRai", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <InputNumber
                                min={0}
                                step="0.01"
                                placeholder="ขนาดพื้นที่ (ไร่)"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="ขนาดพื้นที่ (งาน)"
                              name={["areaSizeByNgan", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <InputNumber
                                min={0}
                                step="0.01"
                                placeholder="ขนาดพื้นที่ (งาน)"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="ขนาดพื้นที่ (วา)"
                              name={["areaSizeByWa", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <InputNumber
                                min={0}
                                step="0.01"
                                placeholder="ขนาดพื้นที่ (วา)"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="ขนาดพื้นที่ (ตารางเมตร)"
                              name={["areaSizeByMeters", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <InputNumber
                                min={0}
                                step="0.01"
                                placeholder="ขนาดพื้นที่ (ตารางเมตร)"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="ปริมาณการใช้น้ำต่อเดือน ลูกบาศก์เมตร (ลบ.ม.)"
                              name={["waterConsumption", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <InputNumber
                                min={0}
                                step="0.01"
                                placeholder="ปริมาณการใช้น้ำต่อเดือน ลูกบาศก์เมตร (ลบ.ม.)"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="จำนวนคนงาน"
                              name={["numberOfWorker", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <InputNumber
                                min={0}
                                placeholder="จำนวนคนงาน"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              label="ชื่อผู้บริหารโรงงานที่พบ"
                              name={["ceoNameOfFactory", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Input
                                placeholder="ชื่อผู้บริหารโรงงานที่พบ"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              label="ตำแหน่งผู้บริหารที่เข้าพบ"
                              name={["ceoPositionOfFactory", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Input
                                placeholder="ตำแหน่งผู้บริหารที่เข้าพบ"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              label="ชื่อผู้ติดต่อ/ผู้ประสานงาน"
                              name={["coordinatorName", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Input
                                placeholder="ชื่อผู้ติดต่อ/ผู้ประสานงาน"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              label="เบอร์โทรศัพท์ผู้ติดต่อ/ผู้ประสานงาน"
                              name={["coordinatorPhoneNumber", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Input
                                prefix={<PhoneFilled />}
                                placeholder="Ex.080-000-0000"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              label="อีเมลผู้ติดต่อ/ผู้ประสานงาน"
                              name={["coordinatorEmail", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                  type: "email",
                                },
                              ]}
                            >
                              <Input
                                prefix={<MailOutlined />}
                                placeholder="Ex.abc@gmail.com,hotmail.com..."
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={16}>
                            <Form.Item
                              label="แนบไฟล์ "
                              name={["filePath", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Upload
                                {...props}
                                accept="image/jpg,image/jpeg,application/pdf"
                                customRequest={(e) => {
                                  onUploadFile(e, k);
                                }}
                                onRemove={(info) => {
                                  onRemoveFile(info, k);
                                }}
                                fileList={
                                  fileList.length > 0
                                    ? fileList.filter(
                                        (obj, index) =>
                                          fileList.findIndex(
                                            (item) =>
                                              item.uid === obj.uid &&
                                              item.index === k
                                          ) === index
                                      )
                                    : undefined
                                }
                                multiple={false}
                              >
                                <Button icon={<UploadOutlined />}>
                                  เลือกไฟล์
                                </Button>
                              </Upload>
                              <span style={{ color: "#667085", fontSize: 13 }}>
                                สามารถ Upload File ได้ 1 File รองรับนามสกุล JPG,
                                PDF ขนาดไม่เกิน 50 Mb
                              </span>
                            </Form.Item>
                          </Col>

                          <Col span={24}>
                            <Divider dashed />
                          </Col>

                          <Col span={24}>
                            <div style={{ fontWeight: 600, fontSize: 16 }}>
                              ด้านผลิตภัณฑ์และบริการ
                            </div>
                          </Col>

                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["productAndServiceWant", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode="multiple"
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {productRequirement &&
                                  productRequirement.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["productAndServiceWant", k]) &&
                              form
                                .getFieldValue(["productAndServiceWant", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={[
                                    "productAndServiceWantSpecify",
                                    `${k}`,
                                  ]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["productAndServiceExpected", `${k}`]}
                            >
                              <Select
                                allowClear
                                mode="multiple"
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {otherProductExpect &&
                                  otherProductExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue([
                              "productAndServiceExpected",
                              k,
                            ]) &&
                              form
                                .getFieldValue(["productAndServiceExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={[
                                    "productAndServiceExpectedSpecify",
                                    `${k}`,
                                  ]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>

                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              ด้านสนับสนุนลูกค้า
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["supportWant", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {customerSupport &&
                                  customerSupport.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["supportWant", k]) &&
                              form
                                .getFieldValue(["supportWant", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["supportWantSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["supportExpected", `${k}`]}
                            >
                              <Select
                                allowClear
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {otherSupportExpect &&
                                  otherSupportExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["supportExpected", k]) &&
                              form
                                .getFieldValue(["supportExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["supportExpectedSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>

                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              ด้านการทำธุรกรรม
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["transactionWant", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {businessRequire &&
                                  businessRequire.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["transactionWant", k]) &&
                              form
                                .getFieldValue(["transactionWant", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["transactionWantSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["transactionExpected", `${k}`]}
                            >
                              <Select
                                allowClear
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                                maxTagCount={"responsive"}
                                mode={"multiple"}
                              >
                                {otherBusinessExpect &&
                                  otherBusinessExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["transactionExpected", k]) &&
                              form
                                .getFieldValue(["transactionExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["transactionExpectedSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>

                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              ด้านการจัดการความสัมพันธ์ (CRM)
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ/คาดหวัง ด้านการจัดการความสัมพันธ์(CRM) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["crmExpected", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                              >
                                {customerExpect &&
                                  customerExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["crmExpected", k]) &&
                              form
                                .getFieldValue(["crmExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["crmExpectedSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ข้อเสนอแนะด้านผลิตภัณฑ์และบริการ (ถ้ามี)"
                              name={["productAndServiceSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="3.ข้อเสนอแนะด้านสนับสนุนลูกค้า (ถ้ามี)"
                              name={["supportSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="4.ข้อเสนอแนะด้านการทำธุรกรรม (อนุมัติ, อนุญาตและสิทธิประโยชน์) (ถ้ามี)"
                              name={["transactionSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="5.ข้อเสนอแนะด้านการจัดการความสัมพันธ์กับลูกค้า (CRM) (ถ้ามี)"
                              name={["crmSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="6.สิ่งที่ไม่พึ่งพอใจต้องการให้ปรับปรุงอย่างเร่งด่วน (ถ้ามี)"
                              name={["notSatisfied", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>
                              {/* Testหัวข้อใหม่ */}
                          <div>
                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 30,
                                marginTop: 20,
                              }}
                            >
                              คำถามใหม่
                              {isNonKpiUser && <div style={{ fontSize: 14, fontWeight: 400 }}>ไม่บังคับกรอกสำหรับผู้ใช้กลุ่มไม่นับ KPI</div>}
                            </div>
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  1.บริษัทขายสินค้าอะไร ให้กับบริษัทอะไร
                                  {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                                </div>

                              </Col>
                              <Form.List name={["sellProductTo",`${k}`]}>
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(({ key, name}) => (
                                      <Col span={24} key={key}>
                                        <Row gutter={16}> 
                                          <Col span={7}>
                                          <NewQuestionItem
                                              label="สินค้า"
                                              name={[name, "productSell"]}
                                              rules={[
                                                {
                                                  required: true,
                                                  whitespace: true,
                                                  message: "โปรดระบุสินค้า",
                                                },
                                                {
                                                  pattern: /^[A-Za-z0-9\u0E00-\u0E7F ]+$/, 
                                                  message: "ห้ามใส่ตัวอักษรพิเศษ",
                                                },
                                              ]}
                                            >
                                              <AutoComplete
                                                value={autoProd}
                                                options={optionsProd}
                                                onSelect={handleSelect}
                                                onChange={setAutoProd}
                                                placeholder="ระบุชื่อสินค้า"
                                                style={{ width: "100%" }}
                                                allowClear
                                                filterOption={(input, option) =>
                                                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                                }
                                              >
                                                
                                              </AutoComplete>
                                            </NewQuestionItem>
                                          </Col>

                                          <Col span={7}>
                                            <NewQuestionItem
                                              label="บริษัท"
                                              name={[name, "companySell"]}
                                              rules={[
                                                {
                                                  required: true,
                                                  whitespace: true,
                                                  message: "โปรดระบุสินค้า",
                                                },
                                                {
                                                  pattern: /^[A-Za-z0-9\u0E00-\u0E7F ]+$/, 
                                                  message: "ห้ามใส่ตัวอักษรพิเศษ",
                                                },
                                              ]}
                                            >
                                              <Autocomplete
                                                allowClear
                                                style={{ width: "100%" }}
                                                subject="eppFactory"
                                                valueField="MerchantNameTH"
                                                placeholder="ระบุบริษัท"
                                                prefixIcon={null}
                                                filterFn={(item) => {
                                                  return item.MerchantNameTH !== 'ไม่มี VOC จากช่องทางนี';}}
                                              />
                                            </NewQuestionItem>
                                          </Col>

                                          <Col span={7}>
                                            <NewQuestionItem
                                              label="อุตสาหกรรม"
                                              name={[name, "industrySell"]}
                                              rules={[
                                                {
                                                  required: true,
                                                  whitespace: true,
                                                  message: "โปรดระบุสินค้า",
                                                },
                                              ]}
                                            >
                                              <Select
                                                allowClear
                                                style={{ width: "100%" }}
                                                placeholder="กรุณาเลือก"
                                              >
                                                {industries.map((item) => (
                                                  <Option key={item.industryId} value={item.industryId}>
                                                    {item.industryNameTh}
                                                  </Option>
                                                ))}
                                              </Select>
                                            </NewQuestionItem>
                                          </Col>

                                          {/* <Col span={2}></Col> */}
                                          <Col span={3} style={{  display: 'flex', alignItems: 'center', marginTop: 30 ,justifyContent: 'flex-end' }}>
                                              <Button
                                                shape="circle"
                                                size="default"
                                                style={{ background: "#FDE7E5", border: "1px solid#FDE7E5" }}
                                                onClick={() => {
                                                  if (fields.length <= 1) {
                                                    message.error("ควรกรอกอย่างน้อย 1 รายการ");
                                                    return;
                                                  }
                                                  remove(name);
                                                }}
                                              >
                                                <DeleteFilled style={{ color: "#F04438" }} />
                                              </Button>
                                              </Col>
                                            </Row>
                                          </Col>
                                        ))}
                                        <Col span={24} style={{ textAlign: 'right' ,marginTop: 30 }}>
                                          <NewQuestionItem>
                                            <Button 
                                              shape="circle"
                                              size="default"
                                              style={{ background: "#F4F6FC", border: "1px solid#F4F6FC" }}
                                              onClick={() => add()}>
                                                <PlusOutlined style={{ color: "#2E90FA" }} />
                                            </Button>
                                          </NewQuestionItem>
                                      </Col>
                                  </>
                                )}
                              </Form.List>

                            </Row>
                              
                            
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                            <Col span={24}><div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              2.บริษัทซื้อสินค้าอะไร จากบริษัทอะไร
                              {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                            </div></Col>
                            <Form.List name={["buyProductFrom",`${k}`]}>
                                {(fields, { add, remove }) => (
                                  <>
                                  {fields.map(({ key, name, ...restField }, k) => (
                                    <Col span ={24}>
                                    <Row gutter={16} key={key}>
                                <Col span={7}>
                                  <NewQuestionItem
                                  label="สินค้า"
                                  name={[name,"productBuy"]}
                                  rules={[
                                    {
                                      required: true,
                                      whitespace: true,
                                      message: "โปรดระบุสินค้า",
                                    },
                                    {
                                      pattern: /^[A-Za-z0-9\u0E00-\u0E7F ]+$/, 
                                      message: "ห้ามใส่ตัวอักษรพิเศษ",
                                    },
                                  ]}
                                >
                                  <AutoComplete
                                    value={autoProd}
                                    options={optionsProd}
                                    onSelect={handleSelect}
                                    onChange={setAutoProd}
                                    placeholder="ระบุชื่อสินค้า"
                                    style={{ width: "100%" }}
                                    allowClear
                                    filterOption={(input, option) =>
                                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                    }
                                  >
                                    
                                  </AutoComplete>
                                  </NewQuestionItem>
                                </Col>
                                <Col span={7}>
                                  <NewQuestionItem
                                      label="บริษัท"
                                      name={[name,"companyBuy"]}
                                      rules={[
                                        {
                                          required: true,
                                          whitespace: true,
                                          message: "โปรดระบุสินค้า",
                                        },
                                        {
                                          pattern: /^[A-Za-z0-9\u0E00-\u0E7F ]+$/, 
                                          message: "ห้ามใส่ตัวอักษรพิเศษ",
                                        },
                                      ]}
                                    >
                                      <Autocomplete
                                          allowClear
                                          style={{
                                            width: "100%",
                                          }}
                                          subject = "eppFactory"
                                          valueField="MerchantNameTH"
                                          placeholder="ระบุบริษัท"
                                          prefixIcon={null}
                                          filterFn={(item) => {
                                            return item.MerchantNameTH !== 'ไม่มี VOC จากช่องทางนี';}}
                                        />
                                    </NewQuestionItem>
                                  </Col>
                                  <Col span={7}>
                                  <NewQuestionItem
                                        label="อุตสาหกรรม"
                                        name={[name,"industryBuy"]}
                                      rules={[
                                        {
                                          required: true,
                                          whitespace: true,
                                          message: "โปรดระบุสินค้า",
                                        },
                                      ]}
                                    >
                                      <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder="กรุณาเลือก"
                                      >
                                        {industries.map((item) => (
                                          <Option key={item.industryId} value={item.industryId}>
                                            {item.industryNameTh}
                                          </Option>
                                        ))}
                                      </Select>
                                    </NewQuestionItem>
                                  </Col>
                                  {/* <Col span={1}></Col> */}
                                  <Col span={3} style={{  display: 'flex', alignItems: 'center', marginTop: 30 ,justifyContent: 'flex-end' }}>
                                    <Button
                                      shape="circle"
                                      size="default"
                                      style={{ background: "#FDE7E5", border: "1px solid#FDE7E5" }}
                                      onClick={() => {
                                        if (fields.length <= 1) {
                                          message.error("ควรกรอกอย่างน้อย 1 รายการ");
                                          return;
                                        }
                                        remove(name);
                                      }}
                                    >
                                      <DeleteFilled style={{ color: "#F04438" }} />
                                    </Button>
                                    </Col>
                                  </Row>
                                </Col>
                                ))}
                                <Col span={24} style={{ textAlign: 'right' ,marginTop: 30 }}>
                                  <NewQuestionItem>
                                    <Button 
                                      shape="circle"
                                      size="default"
                                      style={{ background: "#F4F6FC", border: "1px solid#F4F6FC" }}
                                      onClick={() => add()}>
                                        <PlusOutlined style={{ color: "#2E90FA" }} />
                                    </Button>
                                  </NewQuestionItem>
                              </Col>
                              </>
                              )}
                            </Form.List>
                            </Row>
                            
                              
                            
                          </Col>
                          <Col span={24}>
                            <Row gutter={16}>
                            <Col span={24}><div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              3.แผนการเพิ่มลดการผลิตของบริษัท
                              {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                            </div></Col>

                                <Col span={24}>
                                <Col span={24}>
                                 <NewQuestionItem key={k} name={["add/subtract_capacity",`${k}`]}
                                  rules={[
                                      {
                                        required: true,
                                        message: "กรุณาเลือกอย่างใดอย่างหนึ่ง",
                                      },
                                ]}>
                                      <Radio.Group 
                                      className="custom-radio-gap" 
                                      onChange={handleRadioChange('capacity' , k)} 
                                      options={options} 
                                      value={modes.capacity?.[k] ?? "0"} />
                                  </NewQuestionItem>
                                </Col>
                                </Col>
                                {modes.capacity?.[k] === "1" && (
                                <Col xl={8} lg={24}>
                                  <NewQuestionItem
                                    name={["capacity_add" ,`${k}`]}
                                    label="โปรดระบุ"
                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        max={100} 
                                        defaultValue={0} 
                                        addonAfter="%"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                </Col>
                                )}
                                {modes.capacity?.[k] === "-1" && (
                                <Col xl={8} lg={24}>
                                  <NewQuestionItem
                                    name={["capacity_sub" ,`${k}`]}
                                    label="โปรดระบุ"
                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        max={100} 
                                        defaultValue={0} 
                                        addonAfter="%"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                </Col>
                                )}
                                <Col xl={8} lg={24}>
                                  <NewQuestionItem
                                    name={["newProductLine",`${k}`]}
                                    label = "สินค้าใหม่ (ถ้ามี)"
                                    
                                  >
                                      <Input placeholder="ระบุสินค้าใหม่"/>
                                  </NewQuestionItem>
                                </Col>
                            </Row>
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                            <Col span={24}><div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              4.แผนเพิ่มลดการใช้ ไฟฟ้า น้ำ และ น้ำ RO ของบริษัท
                              {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                            </div></Col>

                            <Col span={24}>
                              <Row gutter={16}>
                                <Col xl={4} lg={6} md = {24}>
                                  <div 
                                  style={{ fontWeight: 500,
                                           fontSize: "14px",
                                           lineHeight: "32px",
                                           fontWeight: "bold"  }}>
                                  4.1 ไฟฟ้า</div>
                                </Col>
                                <Col xl={12} lg = {18} md = {24}>
                                 <NewQuestionItem
                                  name="electricity_add/sub">
                                    <Flex vertical>
                                      <Radio.Group 
                                      block onChange={handleRadioChange("electricity",k)} 
                                      options={options} 
                                      value={modes.electricity?.[k] ?? "0"} />
                                    </Flex>
                                  </NewQuestionItem>
                                </Col>
                                {modes.electricity?.[k] === "1" && (
                                <Col xl={8} lg={24}>

                                  <NewQuestionItem
                                    name={["electricity_add",`${k}`]}
                                    label="โปรดระบุ"

                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="กิโลวัตต์/เดือน"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                </Col>
                                )}
                                {modes.electricity?.[k] === "-1" && (
                                <Col xl={8} lg={24}>

                                  <NewQuestionItem
                                    name={["electricity_sub",`${k}`]}
                                    label="โปรดระบุ"

                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="กิโลวัตต์/เดือน"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                </Col>
                                )}
                                </Row>
                                </Col>

                                <Col span={24}>
                                  <Row gutter={16}>
                                    <Col xl={4} lg={6} md = {24}>
                                    <div 
                                  style={{ fontWeight: 500,
                                           fontSize: "14px",
                                           lineHeight: "32px",
                                           fontWeight: "bold"  }}>
                                  4.2 น้ำ</div>
                                    </Col>
                                    <Col xl={12} lg = {18} md = {24}>
                                 <NewQuestionItem
                                  name="water_add/sub">
                                    <Flex vertical>
                                      <Radio.Group 
                                      block onChange={handleRadioChange('water',k)} 
                                      options={options} 
                                      value={modes.water?.[k] ?? "0"} />
                                    </Flex>
                                  </NewQuestionItem>
                                </Col>
                                {modes.water?.[k] === "1" && (
                                <Col xl={8} lg={24}>

                                  <NewQuestionItem
                                    name={["water_add",`${k}`]}
                                    label="โปรดระบุ"

                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="ลบ.ม./เดือน"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                </Col>
                                )}
                                {modes.water?.[k] === "-1" && (
                                <Col xl={8} lg={24}>

                                  <NewQuestionItem
                                    name={["water_sub",`${k}`]}
                                    label="โปรดระบุ"

                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="ลบ.ม./เดือน"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                </Col>
                                )}
                                </Row>
                                </Col>

                                <Col span={24}>
                                  <Row gutter={16}>
                                    <Col xl={4} lg={6} md = {24}>
                                    <div 
                                  style={{ fontWeight: 500,
                                           fontSize: "14px",
                                           lineHeight: "32px",
                                           fontWeight: "bold"  }}>
                                  4.3 น้ำ RO</div>
                                    </Col>

                                      <Col xl={12} lg={18} md = {24}>
                                 <NewQuestionItem
                                  name="ro_add/sub">
                                    <Flex vertical>
                                      <Radio.Group 
                                      block onChange={handleRadioChange('ro',k)} 
                                      options={options} 
                                      value={modes.ro?.[k] ?? "0"} />
                                    </Flex>
                                  </NewQuestionItem>
                                </Col>
                                {modes.ro?.[k] === "1" && (
                                <Col xl={8} lg={24}>

                                  <NewQuestionItem
                                    name={["ro_add",`${k}`]}
                                    label="โปรดระบุ"

                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="ลบ.ม./เดือน"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                </Col>
                                )}
                                {modes.ro?.[k] === "-1" && (
                                <Col xl={8} lg={24}>

                                  <NewQuestionItem
                                    name={["ro_sub",`${k}`]}
                                    label="โปรดระบุ"

                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="ลบ.ม./เดือน"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                </Col>
                                )}
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  5.บริษัทส่งออกสินค้าไปประเทศอะไร
                                  {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                                </div>
                              </Col>
                              <Form.List name={["bigImportTo",`${k}`]}>
                                {(fields, { add, remove }) => (
                                  <>
                                  {fields.map(({ key, name, ...restField }, k) => (
                                    <Col span ={24}>
                                    <Row gutter={16} key={key}>
                                      <Col xl={8} lg={20} md={20}>
                                        <NewQuestionItem
                                        label="ประเทศ"
                                        name={[name,"country_Import"]}
                                        rules={[
                                          {
                                            required: true,
                                            message: "โปรดระบุ",
                                          },
                                        ]}
                                      >
                                        <MultipleAutoComplete
                                          allowClear
                                          style={{
                                            width: "100%",
                                          }}
                                          placeholder="กรุณาเลือก"
                                          multiple={false}
                                          subject="countryOrderNameTh"
                                          valueField="countryId"
                                          labelField="countryNameTh"
                                        />
                                          {/* <Option value="จีน">จีน</Option>
                                          <Option value="ญี่ปุ่น">ญี่ปุ่น</Option>
                                          <Option value="ฮ่องกง">ฮ่องกง</Option>
                                          <Option value="สิงคโปร์">สิงคโปร์</Option>
                                          <Option value="อินเดีย">อินเดีย</Option>
                                          <Option value="ไต้หวัน">ไต้หวัน</Option>
                                          <Option value="สหรัฐอเมริกา">สหรัฐอเมริกา</Option> */}

                                        </NewQuestionItem>
                                        
                                      </Col>
                                      {/* <Col span={1}></Col> */}
                                      <Col xl={16} lg={4} md={4} style={{  display: 'flex', alignItems: 'center', marginTop: 30 ,justifyContent: 'flex-end' }}>
                                        <Button
                                          shape="circle"
                                          size="default"
                                          style={{ background: "#FDE7E5", border: "1px solid#FDE7E5" }}
                                          onClick={() => {
                                            if (fields.length <= 1) {
                                              message.error("ควรกรอกอย่างน้อย 1 รายการ");
                                              return;
                                            }
                                            remove(name);
                                          }}
                                        >
                                          <DeleteFilled style={{ color: "#F04438" }} />
                                        </Button>
                                      </Col>
                                    </Row>
                                    </Col>
                                    ))}
                                    <Col span={24} style={{ textAlign: 'right',marginTop: 30 }}>
                                      <NewQuestionItem>
                                        <Button 
                                          shape="circle"
                                          size="default"
                                          style={{ background: "#F4F6FC", border: "1px solid#F4F6FC" }}
                                          onClick={() => add()}>
                                            <PlusOutlined style={{ color: "#2E90FA" }} />
                                        </Button>
                                      </NewQuestionItem>
                                    </Col>
                                    </>
                              )}
                            </Form.List>
                            </Row>
                              
                            <Row gutter={16}>
                            <Col span={24}><div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              6.บริษัทมีการลงทุนเรื่องอุตสาหกรรมสะอาดหรือไม่ (ถ้ามีให้ระบุได้มากกว่า 1)
                              {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                            </div></Col>
                              <Col span={24}>
                                  <Col xl={12} md={24}>
                                  <NewQuestionItem name={["reduceCapacityPlan",`${k}`]}
                                  rules={[
                                      {
                                        required: true,
                                        message: "กรุณาเลือกตัวเลือก",
                                      },
                                    ]}
                                  >
                                        <Radio.Group 
                                        className="custom-radio-gap"
                                        onChange={handleRadioLevelChange('CapacityPlan',k,'choicesReducePlan')} 
                                        options={options6} 
                                        value={modes.CapacityPlan?.[k]?.choicesReducePlan ?? "0"}/>
                                  </NewQuestionItem>
                                  </Col>
                              </Col>
                              {modes?.CapacityPlan?.[k]?.choicesReducePlan === "1" && (
                                <Col span={24}>
                                  <Row>
                                    <Col span={24}>
                                        <NewQuestionItem name={['isSelectReduce', `${k}`]}
                                        rules={[
                                                {
                                                  required: true,
                                                  type: 'array',
                                                  min: 1,
                                                  message: "กรุณาเลือกอย่างน้อยหนึ่งตัวเลือก",
                                                },
                                        ]}>
                                          <Checkbox.Group style={{ display: "flex", flexWrap: "wrap", gap: 12 , marginLeft:8  }}
                                            onChange={(checkedValues) => {
                                              if (!checkedValues.includes("อื่นๆ")) {
                                                const prevOther = form.getFieldValue("otherReduce") || {};
                                                form.setFieldsValue({
                                                  otherReduce: {
                                                    ...prevOther,
                                                    [k]: undefined,
                                                  },
                                                });
                                              }
                                            }}
                                          >
                                              {planOptions.map((option, index) => (
                                                <Col xl={4} md={24} key={index}>
                                                  <Checkbox value={option} style={{ width: '150px' }}>{option}</Checkbox>
                                                </Col>
                                              ))}
                                          </Checkbox.Group>
                                        </NewQuestionItem>

                                    </Col>
                                    {form.getFieldValue(["isSelectReduce",k])?.includes("อื่นๆ") && (
                                      <Col span={8}>
                                        <NewQuestionItem
                                        name={["otherReduce",`${k}`]}
                                        label="ระบุ"
                                        rules={[{ required: true, message: 'โปรดระบุ' }]}
                                        preserve={false}
                                        >
                                          <Input placeholder="กรุณากรอก..." />
                                        </NewQuestionItem>
                                      </Col>
                                    )}
                                  </Row>
                                </Col>
                              )}
                              {modes?.CapacityPlan?.[k]?.choicesReducePlan === "0" && (
                                <Col span={24}>
                                  <Col xl={12} md={24}>
                                    <NewQuestionItem name={["futureCapacityPlan",`${k}`]} label="มีแผนนำพลังงานสะอาด มาใช้ในอนาคตหรือไม่ (ถ้ามีให้ระบุได้มากกว่า 1)" preserve={false}
                                    rules={[
                                      {
                                        required: true,
                                        message: "กรุณาเลือกตัวเลือก",
                                      },
                                    ]}
                                  >
                                          <Radio.Group
                                          className="custom-radio-gap"
                                          onChange={handleRadioLevelChange('CapacityPlan',k,'choicesFuturePlan')} 
                                          options={options6} 
                                          value={modes.CapacityPlan?.[k]?.choicesFuturePlan ?? "0"} />
                                    </NewQuestionItem>
                                  </Col>
                              </Col>
                              ) }
                              {modes?.CapacityPlan?.[k]?.choicesFuturePlan === "1" && (
                                <Col span={24}>
                                <Row>
                                  <Col span={24}>
                                  <NewQuestionItem name={['isSelectFuture', `${k}`]}
                                  rules={[
                                          {
                                            required: true,
                                            type: 'array',
                                            min: 1,
                                            message: "กรุณาเลือกอย่างน้อยหนึ่งตัวเลือก",
                                          },
                                  ]}>
                                          <Checkbox.Group style={{ display: "flex", flexWrap: "wrap", gap: 12 , marginLeft:8  }}
                                            onChange={(checkedValues) => {
                                              if (!checkedValues.includes("อื่นๆ")) {
                                                const prevOther = form.getFieldValue("otherFuture") || {};
                                                form.setFieldsValue({
                                                  otherFuture: {
                                                    ...prevOther,
                                                    [k]: undefined,
                                                  },
                                                });
                                              }
                                            }}
                                          >
                                              {planOptions.map((option, index) => (
                                                <Col xl={4} md={24} key={index} >
                                                  <Checkbox value={option} style={{ width: '150px' }}>{option}</Checkbox>
                                                </Col>
                                              ))}
                                          </Checkbox.Group>
                                        </NewQuestionItem>
                                  </Col>
                                  {form.getFieldValue(["isSelectFuture",k])?.includes("อื่นๆ") && (
                                    <Col span={8}>
                                      <NewQuestionItem
                                      name={["otherFuture",`${k}`]}
                                      label="ระบุ"
                                      rules={[{ required: true, message: 'โปรดระบุ' }]}
                                      preserve={false}
                                      >
                                        <Input placeholder="กรุณากรอก..." />
                                      </NewQuestionItem>
                                    </Col>
                                  )}
                                </Row>
                              </Col>
                              )}
                            </Row>
                          </Col>  
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  7.บริษัทมีการติดตั้ง Solar cell หรือไม่ ถ้ามีกำลังผลิต Solar cell  เท่าไร
                                  {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                                </div>
                              </Col>

                              <Col span={8}>
                              <NewQuestionItem
                                    name={["solarcellCapacity",`${k}`]}
                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="MVA (เมกะโวลต์แอมแปร์)"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                
                              </Col>
                            </Row>
                              
                            
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  8.โรงงานของท่านมีปริมาณการใช้น้ำต่อเดือนเท่าไร
                                  {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                                </div>
                              </Col>

                              <Col span={8}>
                              <NewQuestionItem
                                    name={["waterUsage",`${k}`]}
                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="ลบ.ม./เดือน"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                
                              </Col>
                            </Row>
                              
                            
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  9.โรงงานของท่านมีปริมาณการใช้ไฟฟ้าต่อเดือนเท่าไร
                                  {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                                </div>
                              </Col>

                              <Col span={8}>
                              <NewQuestionItem
                                    name={["electricityUsage",`${k}`]}
                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="KVA (กิโลโวลต์แอมแปร์)"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                
                              </Col>
                            </Row>
                              
                            
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  10.โรงงานของท่านมีปริมาณน้ำเสียต่อเดือนเท่าไร
                                  {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                                </div>
                              </Col>

                              <Col span={8}>
                              <NewQuestionItem
                                    name={["wasteWaterVolume",`${k}`]}
                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="ลบ.ม./เดือน"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                
                              </Col>
                            </Row>
                              
                            
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  11.โรงงานของท่านมีกำลังการผลิตเป็นไปตามแผนหรือไม่
                                  {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                                </div>
                              </Col>

                              <Col span={24}>
                              <Col span={24}>
                                 <NewQuestionItem
                                  name={["capacity_plan",`${k}`]}
                                  rules={[
                                        {
                                          required: true,
                                          message: "กรุณาเลือกอย่างใดอย่างหนึ่ง",
                                        },
                                  ]}>
                                      <Radio.Group
                                      className="custom-radio-gap"
                                      options={[
                                        { label: "เป็นไปตามแผน", value: true },
                                        { label: "ไม่เป็นไปตามแผน", value: false },
                                      ]} defaultValue="true" />
                                  </NewQuestionItem>
                              </Col>
                              </Col>
                            </Row>
                              
                            
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  12.บริษัทท่านได้รับผลกระทบต่อมาตรการทางภาษีนำเข้าสินค้าของสหรัฐอเมริกาหรือไม่
                                  {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                                </div>
                              </Col>

                              <Col span={24}>
                                <Col span={24}>
                                 <NewQuestionItem
                                  name={["importTax",`${k}`]}
                                  rules={[
                                        {
                                          required: true,
                                          message: "กรุณาเลือกอย่างใดอย่างหนึ่ง",
                                        },
                                  ]}>
                                      <Radio.Group 
                                      className="custom-radio-gap"
                                      options={[
                                      { label: "ใช่", value: true },
                                      { label: "ไม่ใช่", value: false },
                                    ]} defaultValue= "true" />
                                  </NewQuestionItem>
                              </Col>
                              </Col>
                            </Row>
                              
                            
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  13.สินค้าส่งออกของบริษัทท่านเป็นประเภทอะไรที่เข้าข่ายได้รับผลกระทบจากมาตรการทางภาษีนำเข้าสินค้าของสหรัฐอเมริกา (ถ้ามี)
                                </div>
                              </Col>
                              <Form.List name={["TaxEffect",`${k}`]}>
                                {(fields, { add, remove }) => (
                                  <>
                                  {fields.map(({ key, name, ...restField }, index) => (
                                    <Col span ={24}>
                                      <Row gutter={16} key={key}>
                                        <Col xl={8} lg={10}>
                                          <NewQuestionItem
                                          label="ประเภทกลุ่มสินค้า"
                                          name={[name ,"industryTaxImport"]}
                                          dependencies={[name, "productTaxImport"]}
                                          rules={[
                                            () => ({
                                              validator(_, value) {
                                                const allValues = form.getFieldValue(["TaxEffect", `${k}`]);
                                                const currentItem = Array.isArray(allValues) ? allValues[name] : undefined;
                                                const hasProduct = currentItem?.productTaxImport;
                                                if (!value && hasProduct) {
                                                  return Promise.reject(new Error("กรุณาเลือกประเภทกลุ่มสินค้าให้ครบถ้วน"));
                                                }
                                                return Promise.resolve();
                                              },
                                            }),
                                          ]}
                                        >
                                          <Select
                                            allowClear
                                            style={{
                                              width: "100%",
                                            }}
                                            placeholder="กรุณาเลือก"
                                          >
                                          {industries.map((item) => (
                                                  <Option key={item.industryId} value={item.industryId}>
                                                    {item.industryNameTh}
                                                  </Option>))}
                                          </Select>
                                          </NewQuestionItem>
                                          
                                        </Col>
                                        <Col xl={8} lg={10}>
                                          <NewQuestionItem
                                            label="ผลิตภัณฑ์สินค้า"
                                            name={[name ,"productTaxImport"]}
                                            dependencies={[name, "industryTaxImport"]}
                                            rules={[
                                              () => ({
                                                validator(_, value) {
                                                  const allValues = form.getFieldValue(["TaxEffect", `${k}`]);
                                                  const currentItem = Array.isArray(allValues) ? allValues[name] : undefined;
                                                  const hasIndustry = currentItem?.industryTaxImport;
                                                  if (!value && hasIndustry) {
                                                    return Promise.reject(new Error("กรุณาระบุชื่อสินค้าให้ครบถ้วน"));
                                                  }
                                                  return Promise.resolve();
                                                },
                                              }),
                                              {
                                                pattern: /^[A-Za-z0-9\u0E00-\u0E7F ]+$/, 
                                                message: "ห้ามใส่ตัวอักษรพิเศษ",
                                              },
                                            ]}
                                          >
                                            <AutoComplete
                                              value={autoProd}
                                              options={optionsProd}
                                              onSelect={handleSelect}
                                              onChange={setAutoProd}
                                              placeholder="ระบุชื่อสินค้า"
                                              style={{ width: "100%" }}
                                              allowClear
                                              filterOption={(input, option) =>
                                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                              }
                                            >
                                            </AutoComplete>
                                          </NewQuestionItem>
                                        </Col>
                                        <Col xl={8} lg={4} style={{ display: 'flex', alignItems: 'center', marginTop: 30 ,justifyContent: 'flex-end'}}>
                                            <Button 
                                              shape="circle"
                                              size="default"
                                              style={{ background: "#FDE7E5", border: "1px solid#FDE7E5" }}
                                              onClick={() => remove(name)} >
                                                <DeleteFilled style={{ color: "#F04438" }} />
                                            </Button>
                                            </Col>
                                    </Row>
                                          </Col>
                                    ))}
                                    <Col span={24} style={{ textAlign: 'right' ,marginTop: 30 }}>
                                      <NewQuestionItem>
                                        <Button 
                                          shape="circle"
                                          size="default"
                                          style={{ background: "#F4F6FC", border: "1px solid#F4F6FC" }}
                                          onClick={() => add()}>
                                            <PlusOutlined style={{ color: "#2E90FA" }} />
                                        </Button>
                                      </NewQuestionItem>
                                    </Col>
                                  </>
                                )}
                              </Form.List>
                            </Row>
                              
                            
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  14.จากมาตรการทางภาษีการค้าของสหรัฐอเมริกา อาจส่งผลกระทบต่อการส่งออก และสร้างความท้าทายให้แข็งขัน
                                  บริษัทประเมินมูลค่าความเสียหายจากกำแพงภาษีทั้งทางตรงและทางอ้อม เป็นจำนวนเงินต่อปีประมาณเท่าไหร่
                                  {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                                </div>
                              </Col>

                              <Col span={8}>
                              <NewQuestionItem
                                    name={["estimatedCost",`${k}`]}
                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <InputNumber 
                                        min={0} 
                                        defaultValue={0} 
                                        addonAfter="ล้านบาท/ปี"
                                        style={{
                                          width: "100%",
                                        }}
                                        inputStyle={{ textAlign: 'right' }}/>
                                  </NewQuestionItem>
                                
                              </Col>
                            </Row>
                              
                            
                          </Col>
                          <Col span={24}>

                            <Row gutter={16}>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >
                                  15.อยากให้ กนอ. /รัฐบาล มีส่วนในการช่วยท่านได้อย่างไร
                                  {!isNonKpiUser && <span style={{color:'red' ,fontWeight: 'normal', fontSize: 14,}}> *</span>}

                                </div>
                              </Col>

                              <Col span={24}>
                              <NewQuestionItem
                                    name={["remark_ieat",`${k}`]}
                                    rules = {[
                                      {
                                        required : true,
                                        message : "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                      <Input.TextArea placeholder="ระบุ"/>
                                  </NewQuestionItem>
                                
                              </Col>
                            </Row>
                          </Col>
                          </div>
                          {/*End Testหัวข้อใหม่ */}
                          {/* มีความสนใจด้าน นวัตกรรม/SMEs เข้ามาเป็นส่วนหนึ่งใน Supply Chain */}
                           <Col span={24}>
                            <Row gutter={16}>  
                              <Col span={24}>
                              <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                    marginTop: 20,
                                  }}
                                >มีความสนใจด้าน นวัตกรรม/SMEs เข้ามาเป็นส่วนหนึ่งใน Supply Chain</div>
                              </Col>
                              <Col span={24}>
                                  <Form.Item
                                    label="1.ปัจจุบันบริษัทของท่านมีความสนใจนวัตกรรมด้านใดบ้าง เพื่อพัฒนาระบบการจัดการภายในบริษัท"
                                    name = {["innovationInterest",`${k}`]}
                                  >
                                  <Input.TextArea placeholder="รายละเอียด" />
                                  </Form.Item>
                              </Col>
                              <Col span={24}>
                                  <Form.Item
                                    label="2.หากมีธุรกิจ SMEs สนใจเข้ามาเป็นส่วนหนึ่งของ Supply Chain ในธุรกิจของท่าน ท่านมีความสนใจหรือไม่"
                                    name = {["smesInterest",`${k}`]}
                                  >
                                  <Select
                                    allowClear
                                    style={{
                                      width: "100%",
                                    }}
                                    placeholder="กรุณาเลือก"
                                  >
                                    <Option value={true}>มี</Option>
                                    <Option value={false}>ไม่มี</Option>
                                  </Select>
                                  </Form.Item>
                              </Col>
                              <Col span={24}>
                                  <Form.Item
                                    label="3.หากสนใจ ท่านมีความสนใจด้านใดบ้าง โปรดระบุ"
                                    name = {["interestDetail", `${k}`]}
                                  >
                                  <Input.TextArea placeholder="รายละเอียด" />
                                  </Form.Item>
                              </Col>
                            </Row>
                          </Col> 

                          {/* จบหัวข้อความสนใจ */}
                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              แผนการซื้อ/เช่าที่ดิน เพื่อประกอบอุตสาหกรรม
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีแผนการซื้อ/เช่าที่ดิน เพื่อประกอบอุตสาหกรรมในอนาคตหรือไม่"
                              name={["buyOrRentLand", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                <Option value={true}>มี</Option>
                                <Option value={false}>ไม่มี</Option>
                                <Option value={-1}>ไม่ทราบ</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          {form.getFieldValue(["buyOrRentLand", k]) ===
                            true && (
                            <>
                              <Col span={24}>
                                <Form.Item
                                  label="2.ลูกค้ามีแผนการซื้อ/เช่าที่ดิน เพื่อประกอบอุตสาหกรรมในพื้นที่ใด โปรดระบุ ประเทศ/จังหวัด"
                                  name={["buyOrRentLandProvince", `${k}`]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "โปรดระบุ",
                                    },
                                  ]}
                                >
                                  <Select
                                    allowClear
                                    style={{
                                      width: "100%",
                                    }}
                                    placeholder="กรุณาเลือก"
                                  >
                                    {provinces.map((item) => (
                                      <Option
                                        key={item.provinceCode}
                                        value={item.provinceCode}
                                      >
                                        {item.provinceNameTh}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col span={24}>
                                <Form.Item
                                  label="3.ที่ดินที่ลูกค้ามีแผนการซื่อ/เช่า เพื่อใช้ในการประกอบอุตสาหกรรมใด"
                                  name={["buyOrRentLandEstate", `${k}`]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "โปรดระบุ",
                                    },
                                  ]}
                                >
                                  <Select
                                    allowClear
                                    style={{
                                      width: "100%",
                                    }}
                                    placeholder="กรุณาเลือก"
                                  >
                                    {industries.map((item) => (
                                      <Option
                                        key={item.industryId}
                                        value={item.industryId}
                                      >
                                        {item.industryNameTh}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col span={24}>
                                <Form.Item
                                  label="4.ลูกค้ามีแผนการซื่อ/เช่าที่ดิน เพื่อใช้ในการประกอบอุตสาหกรรมในปีใด"
                                  name={["buyOrRentLandYear", `${k}`]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "โปรดระบุ",
                                    },
                                  ]}
                                >
                                  <Select
                                    allowClear
                                    style={{
                                      width: "100%",
                                    }}
                                    placeholder="กรุณาเลือก"
                                  >
                                    {/* {(() => {
                                      let arr = [];
                                      for (let i = 0; i < 5; i++) {
                                        arr.push(
                                          <Option value={parseInt(years - i)}>
                                            {parseInt(years) + 543 - i}
                                          </Option>
                                        );
                                      }
                                      return arr;
                                    })()} */}
                                    <Option key={3} value={3}>
                                      ภายใน 3 ปี
                                    </Option>
                                    <Option key={5} value={5}>
                                      ภายใน 5 ปี
                                    </Option>
                                    <Option key={10} value={10}>
                                      ภายใน 10 ปี
                                    </Option>
                                    <Option key={99} value={99}>
                                      มากกว่า 10 ปี
                                    </Option>
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col span={24}>
                                <Form.Item
                                  label="5.ลูกค้าต้องการพื้นที่จำนวนกี่ไร่"
                                  name={["buyOrRentLandRai", `${k}`]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "โปรดระบุ",
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    min={0}
                                    step={0.01}
                                    placeholder="กรุณาเลือก"
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                              </Col>
                            </>
                          )}

                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              ช่องทางการสื่อสารและการให้บริการที่ลูกค้าใช้ในการติดต่อ
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1. ช่องทาง Digital ที่ท่านสะดวกใช้ในการติดต่อสื่อสารกับ กนอ. คือช่องทางใด (ตอบได้มากกว่า 1 ข้อ)"
                              name={["digitalContact", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode="multiple"
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {touchPointChannel &&
                                  touchPointChannel.map((item) => (
                                    <Option value={item.dataId}>
                                      {item.dataDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["digitalContact", k]) &&
                              form
                                .getFieldValue(["digitalContact", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["digitalContactSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2. ช่องทาง Physical ที่ท่านสะดวกใช้ในการติดต่อสื่อสารกับ กนอ. คือช่องทางใด (ตอบได้มากกว่า 1 ข้อ)"
                              name={["physicalContact", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode="multiple"
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {touchPointChannelPhysical.map((item) => (
                                  <Option value={item.dataId}>
                                    {item.dataDetailTh}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="3.ข้อเสนอแนะ ช่องทางการสื่อสารและการให้บริการที่ลูกค้าใช้ในการติดต่อ (ถ้ามี)"
                              name={["contactSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ))}

                <Col span={24}>
                  <Button
                    style={{
                      background: "#2E90FA",
                      color: "#fff",
                      fontWeight: 500,
                    }}
                    onClick={addElems}
                  >
                    <PlusOutlined /> เพิ่ม
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        <FloatButton.BackTop
          className="custom-float-btn"
          icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
          shape="square"
          style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
        />
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />

      <ConfirmModal
        actionType={"delete"}
        title={"ยืนยันการลบข้อมูล"}
        modalText={"คุณต้องการลบข้อมูล ?"}
        open={confirmModal.type === "delete" ? confirmModal.show : false}
        onOk={() => {
          removeElems();
        }}
        onCancel={() => {
          setConfirmModal({
            id: 0,
            type: "",
            show: false,
          });
        }}
      />
    </WithSidebar>
  );
};
